import {
  Cell,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
  Legend,
  type TooltipValueType,
} from "recharts";
import type { T_ChartData } from "@lattice/frontend/types/charts";
import {
  CHART_COLORS,
  TOOLTIP_STYLE,
  TOOLTIP_LABEL_STYLE,
  TOOLTIP_ITEM_STYLE,
  formatLargeNumber,
} from "./chart-theme";

export const PieChartComponent = ({ data }: { data: T_ChartData }) => {
  return (
    <div className="h-72 w-full min-w-0">
      <ResponsiveContainer
        width="100%"
        height={288}
        minWidth={240}
        minHeight={288}
      >
        <PieChart margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
          <Pie
            data={data.data}
            cx="50%"
            cy="50%"
            innerRadius={60}
            outerRadius={80}
            paddingAngle={5}
            dataKey="value"
            nameKey="label"
          >
            {data.data.map((_entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={CHART_COLORS[index % CHART_COLORS.length]}
              />
            ))}
          </Pie>
          <Tooltip
            contentStyle={TOOLTIP_STYLE}
            labelStyle={TOOLTIP_LABEL_STYLE}
            itemStyle={TOOLTIP_ITEM_STYLE}
            wrapperStyle={{ zIndex: 1000 }}
            allowEscapeViewBox={{ x: true, y: true }}
            formatter={(value?: TooltipValueType) =>
              typeof value === "number" ? formatLargeNumber(value) : undefined
            }
          />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};
